/**
 * 获取网络信息
 * @returns
 */
export function getNetworkInfo() {
    if (typeof navigator !== 'undefined' && 'connection' in navigator) {
        const connection = navigator.connection;
        return JSON.stringify({
            downlink: connection.downlink,
            effectiveType: connection.effectiveType,
            rtt: connection.rtt,
            saveData: connection.saveData
        });
    }
    else {
        return '';
    }
}
